import type { InjectionKey } from 'vue'

import type { ButtonProps } from './button'

export interface ButtonGroupContext {
  size?: ButtonProps['size']
  type?: ButtonProps['type']
}

export const ButtonGroupContextKey: InjectionKey<ButtonGroupContext> = Symbol('ButtonGroupContextKey')
